<template>
  <div style="margin-right:5rem">
    <div class="row gx-3">
      <div :class="title.class || 'col-3'" v-for="(title,i) in titleList" :key="i">
        <span class="text-danger" v-if="title.required">* </span>
        <label class="form-label">{{title.name}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="text" :class="['form-control',submitted && (!showBaseInfo.name ||  showBaseInfo.name.length > 50)&& 'is-invalid']"  :placeholder="this.$t('page.product-library.PleaseEnterName')" v-model="showBaseInfo.name">
        <div
          v-show="submitted && (!showBaseInfo.name ||  showBaseInfo.name.length > 50)"
          class="invalid-feedback">
          <span>{{
            !showBaseInfo.name?validationTips.nameNotNull:validationTips.charLengthLE50
          }}</span>
        </div>
      </div>
      <div class="col-1">
        <el-switch
          v-model="showBaseInfo.is_import_pump"
          inline-prompt
          :active-text="this.$t('base.yes')"
          :inactive-text="this.$t('base.no')"
        />
      </div>
      <div class="col-1">
        <el-switch
          v-model="showBaseInfo.is_iot_ready"
          inline-prompt
          :active-text="this.$t('base.yes')"
          :inactive-text="this.$t('base.no')"
        />
      </div>
      <div class="col-5">
        <div class="position-relative">
          <textarea  class="form-control" :placeholder="this.$t('page.atlas-analysis.PleaseInput')" rows="1" maxlength="200" v-model="showBaseInfo.description"></textarea>
          <span class="position-absolute fs-12" style="bottom:0.2rem;right:0.5rem;color:#909399">{{(showBaseInfo.description && showBaseInfo.description.length) || 0}}/200</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update:baseInfo"],
  props:{
    submitted:Boolean,
    validationTips:Object,
    baseInfo:{
      type:Object,
      default:()=>{
        return {
          name:'',
          description:'',
          is_import_pump: false,
          is_iot_ready: false,
        }
      }
    }
  },
  watch:{
    showBaseInfo: {
      handler (newVal) {
        this.$emit("update:baseInfo", newVal);
      },
      deep: true
    },
    baseInfo: {
      handler (newVal) {
        this.showBaseInfo = newVal
      },
      deep: true,
    }
  },
  data(){
    return{
      titleList:[{
        name:this.$t('page.work-order.device.name'),
        class: "",
        required:true
      },
      {
        name:this.$t('base.import_pump'),
        class: "col-1",
        required:true
      },
      {
        name:this.$t('base.iot_ready'),
        class: "col-1",
        required:true
      },
      {
        name:this.$t('page.atlas-analysis.describe'),
        class: "col-5",
        required:false
      }],
      showBaseInfo:{}
    }
  }
}
</script>